import { gsap } from '../global/gsap';

const initScrollTo = (sections) => {
    sections.forEach((section) => {
        const scrollButton = section.querySelector('.js-scroll-button');
        if(scrollButton) {
            let target = document.querySelector(`.${scrollButton.dataset.target}`);
        
            if(target == null) {
                target = section.nextElementSibling;
            }

            scrollButton.addEventListener('click', () => {
                gsap.to(window, { duration: 1, scrollTo: target, ease: 'power3.inOut' });
            });
        }
    });
};

export default initScrollTo;
